import React from "react";
import { QuickPayTypeDto } from "@inosio/payments-sdk";
import { Box, ButtonBase, Card, CardContent, CardMedia, css, Dialog, DialogContent, Grid, Typography, useMediaQuery } from "@mui/material";
import WhiteInosio from "../../../icons/whiteinosio.svg";
import { useSelector } from "react-redux";
import { HashLoader } from "react-spinners";
import { makeStyles } from "@mui/styles";
import QuickPayError from "../../../icons/Badrequesterror.svg";
import CheckOutGuest from "../../../icons/CheckOutGuest.svg";
import { selectPropertyGroupDetailsState } from "../../../shared/sagas/propertyGroups/propertyGroupsSlice";

const useStyles = makeStyles((theme) => ({
  errorText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#14142B !important',
    textAlign: 'center',
  },
}))

interface ModalProps {
  open: boolean;
  onContinue: (item: QuickPayTypeDto) => void;
}
const QuickPayItemModal = (props: ModalProps) => {
  const classes = useStyles();
  const { open, onContinue } = props
  const isOnMobileScreen = useMediaQuery("(max-width:600px)");
  const style = {
    height: isOnMobileScreen ? "100%" : "523px",
  };
  // const { companyResponse, isGettingCompanyFailed } = useSelector(selectApplicationsState);
  const { propertyGroupDetails: PropertyGroupDetails, isFetchingPropertyGroupDetailsFailed } = useSelector(selectPropertyGroupDetailsState);

  const override = css`
    display: block;
    margin: 40% auto;
  `;

  return (
    <Dialog
      open={open}
      fullScreen={isOnMobileScreen}
      BackdropProps={{
        invisible: true,
      }}
      fullWidth={true}
      disableEnforceFocus
      style={{
        background: "none",
      }}
      PaperProps={{
        style: {
          pointerEvents: "auto",
          borderRadius: isOnMobileScreen ? "0px" : "24px",
          width: isOnMobileScreen ? "100%" : "472px",
          boxShadow: "none",
          overflow: "hidden"
        },
      }}
      disableEscapeKeyDown={true}
    >
      <DialogContent>
        <Box sx={style}>
          <Grid item display='flex' justifyContent='space-between' flexDirection='column' sx={{ height: '100%' }} >
            <Grid item display="flex" flexDirection="column">
              {isOnMobileScreen ?
                <Grid item display='flex' justifyContent='center' pl={4} sx={{ width: '340px' }}>
                  <img src={WhiteInosio} style={{ width: "75px", height: "75px" }} alt="logo" />
                  <Typography
                    sx={{
                      fontFamily: "Work Sans",
                      fontStyle: 'normal',
                      fontWeight: 700,
                      fontSize: '18px',
                      lineHeight: '23px',
                      color: '#14142B',
                      textAlign: 'left',
                      padding: '15px'
                    }}>
                    {PropertyGroupDetails.CompanyName}
                  </Typography>
                </Grid>
              : <></>}

              <Box>
                {(isFetchingPropertyGroupDetailsFailed) ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '60px' }}>
                    <img src={QuickPayError} width={177} height={209} alt='Quick pay error' />
                    <Typography className={classes.errorText} sx={{ mt: 6, mx: 4 }}>No company found for this page URL. Please contact the Property Manager if you feel you have reached this page in error.</Typography>
                  </Box>
                ) : PropertyGroupDetails?.CompanyName && (PropertyGroupDetails?.PaymentsSettings?.QuickPayEnabled === false || !PropertyGroupDetails?.PaymentsSettings?.QuickPayTypes?.length) ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '60px' }}>
                    <img src={QuickPayError} width={177} height={209} alt='Quick pay error' />
                    <Typography className={classes.errorText} sx={{ mt: 6, mx: 4 }}>Quick payments are not currently accepted. Please contact the Property Manager if you feel you have reached this page in error.</Typography>
                  </Box>
                ) : PropertyGroupDetails?.CompanyName && PropertyGroupDetails?.PaymentsSettings?.QuickPayEnabled === true ? (
                  <Box>
                    <Typography id='paymentReq' sx={{
                      fontFamily: "Open Sans",
                      fontStyle: 'normal',
                      fontWeight: 700,
                      fontSize: '18px',
                      lineHeight: '22px',
                      color: '#14142B',
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '30px'
                    }}>
                      Which item would you like to pay?
                    </Typography>            
                    <Box sx={{ 
                      mt: 2,
                      pt: 4,
                      height: isOnMobileScreen ? 'auto': 380,
                      width: '100%',
                      overflowY: 'auto',
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center',
                      "&::-webkit-scrollbar": {
                        width: 7,
                      },
                      "&::-webkit-scrollbar-track": {
                        boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                        borderRadius: '24px',
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "darkgrey",
                        borderRadius: '24px',
                      },
                    }}>
                      {PropertyGroupDetails?.PaymentsSettings?.QuickPayTypes?.map((item: QuickPayTypeDto, index: number) => (
                        <Card key={index} sx={{ 
                          padding: '0',
                          maxWidth: 340,
                          width: 'calc( 100% - 48px )',
                          minHeight: 90,
                          boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
                          borderRadius: '20px',
                          marginBottom: "24px",
                        }}>
                          <ButtonBase 
                            sx={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              justifyContent: 'space-between',
                              width: '100%',
                              height: '100%',
                              padding: '20px',
                              textAlign: 'initial',
                            }}
                            onClick={()=> onContinue(item)}
                          >
                            <CardMedia
                              component="img"
                              sx={{ width: 79 }}
                              image={CheckOutGuest}
                              alt="Quick Pay Item"
                            />
                            <CardContent sx={{ width: 'calc( 100% - 90px )' }}>
                              <Typography sx={{
                                fontFamily: "Open Sans",
                                fontStyle: 'normal',
                                fontWeight: 600,
                                fontSize: '18px',
                                lineHeight: '25px',
                                color: '#14142B',
                                // whiteSpace: "nowrap",
                                // textOverflow: 'ellipsis',
                                // overflow: 'hidden',
                              }}>
                                {item.Label}
                              </Typography>
                            </CardContent>
                          </ButtonBase>
                        </Card>                    
                      ))}
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{ width: '100%' }}>
                    <HashLoader color={"#D3D3D3"} loading={true} size={100} css={override} />
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default QuickPayItemModal;
